import api from "../../APIIntercepter";

async function getSeminarsAPI() {
  const res = await api.get("/seminars");
  return res.data;
}

async function getSeminarByIdAPI(seminarId) {
  const res = await api.get("/studentseminarassign/getMyPaidSeminar/" + seminarId);
  return res.data;
}

async function getMyAssignedSeminarsAPI() {
  const res = await api.get("/studentseminarassign/getMyPaidSeminars");
  return res.data;
}

async function getSeminarFilesAPI(seminarId) {
  const res = await api.get("/seminarfiles?id=" + seminarId);
  return res.data;
}

async function submitSeminarBankSlipAPI(params) {
  const res = await api.post("/studentseminarassign", params);
  return res.data;
}

async function getMySeminarPaymentsByStatusAPI(status) {
  const res = await api.get(`/studentseminarassign/getMyPaidSeminarsByStatus/${status}`);
  return res.data;
}

export {
  getSeminarsAPI,
  getMyAssignedSeminarsAPI,
  getSeminarFilesAPI,
  getSeminarByIdAPI,
  submitSeminarBankSlipAPI,
  getMySeminarPaymentsByStatusAPI,
};